import * as React from 'react';
import { useField } from 'formik';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { hasValue } from './inputHelpers';

interface IProps {
  name: string
  maxLength?: number
}

const XTextInput = ({ name, maxLength, margin = 'dense', ...props }: TextFieldProps & IProps) => {
  const [field, meta] = useField({ name });
  const error = hasValue(meta.error) ? meta.error : undefined;
  const showError = Boolean(error && meta.touched);

  const currentLength = (field.value || '').length;

  const helperTextNode = React.useMemo(() => {
    const hasHelperText = showError || props.helperText || maxLength;
    if (!hasHelperText) return undefined;

    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <span>{showError ? error : props.helperText}</span>
        {maxLength && <span>{currentLength}/{maxLength}</span>}
      </div>
    );
  }, [showError, props.helperText, maxLength, error, currentLength]);

  return (
    <TextField
      {...field}
      {...props}
      margin={margin}
      fullWidth
      error={showError}
      helperText={helperTextNode}
      value={field.value || ''}
      autoComplete="off"
      inputProps={{
        ...props.inputProps,
        maxLength
      }}
      FormHelperTextProps={{
        component: 'div',
        sx: { width: '100%' }
      } as any}
    />
  );
};

export default XTextInput;
